import request from "../../request";

/**
 *  新增积分获取规则
 */
export function insertPointsRule(item) {
    return request({
        url: 'sys/PointsRule/insertPointsRule',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}
/**
 * 删除积分获取规则
 */
export function deletePointsRule(id) {
    return request({
        url: 'sys/PointsRule/deletePointsRule',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: id,
    })
}

/**
 *  积分规则分页
 */
export function selectPointsRuleByPage(query) {
    return request({
        url: 'sys/PointsRule/GetPointsRuleByPage',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}

/**
 *  积分获取明细汇总-每个人的剩余积分
 */
export function selectTotalPointsPage(query) {
    return request({
        url: 'sys/PointsRuleLibraryWeb/GetSummaryLibraryByPage',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}
/**
 *  积分获取明细汇总-查询个人的积分获取明细
 */
export function selectGainDetailByCoach(query) {
    return request({
        url: 'sys/PointsRuleLibraryWeb/GetLibraryPageByCoachId',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}
